import Man from "../../assets/manu.png";
import Forum from "../../assets/forum.png";
import Liver from "../../assets/liver.png";
import Transfer from "../../assets/transfer.png";

export const ForumsData = [
  {
    name: "Manchester United",
    members: "53 Members",
    bgColor: "#ea014f",
    image: Man
  },
  {
    name: "Sports News",
    members: "230 Members",
    bgColor: "#4c5162",
    image: Forum
  },
  {
    name: "Liverpool",
    members: "430 Members",
    bgColor: "#74ada4",
    image: Liver
  },
  {
    name: "Transfer News",
    members: "53 Members",
    bgColor: "#115a77",
    image: Transfer
  },
];